import { comics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';
import SectionHeader from './SectionHeader';

export default function LatestComics() {
  const list = comics.slice(0, 8);
  return (
    <section className="section-pad bg-background-100">
      <div className="container-page">
        <SectionHeader
          eyebrow="今日更新"
          title="最新上线的魔性爆笑漫画"
          desc="每天 10:00 与 18:00 准时上新，追更从此不迷路。"
          linkTo="/category/hot"
          linkLabel="看全部更新"
        />
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 md:gap-5">
          {list.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}